import React, { useState, useEffect } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db, storage } from "../../firebase";
import "./KsatRegistration.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { jsPDF } from "jspdf";
import logo from "../../assets/images/logo.jpg"; // import your logo

const KsatRegistration = () => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobile: "",
    email: "",
    class: "",
    fatherName: "",
    fatherNumber: "",
    motherName: "",
    motherNumber: "",
    examDate: "",
    address: "",
    RegNo: "",
    dob: "",
    schoolName: "",
  });
  const [examDates, setExamDates] = useState([]); // 🔹 dynamic dates
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // 🔹 Fetch exam dates from Firestore
  useEffect(() => {
    const fetchExamDates = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "testSchedule_db"));
        const today = new Date();
        today.setHours(0, 0, 0, 0); // normalize to midnight

        const dates = querySnapshot.docs
          .map((doc) => doc.data().date) // "2026-03-03"
          .map((dateStr) => {
            const d = new Date(dateStr);
            d.setHours(0, 0, 0, 0); // normalize
            return d;
          })
          .filter((date) => date >= today)
          .sort((a, b) => a - b);

        setExamDates(dates);
      } catch (error) {
        console.error("Error fetching exam dates:", error);
      }
    };

    fetchExamDates();
  }, []);
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  // Helper function: convert image URL → Base64
  const getBase64FromFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  function randomShortId(length = 6) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  }

  async function generateExamRegNo(examCode = "KSAT", year = "2025") {
    const shortId = randomShortId();
    return examCode + year + shortId;
  }

  const generatePDF = async (formData) => {
    const pdf = new jsPDF("p", "pt", "a4"); // portrait, points, A4
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let y = 80; // starting y position after title/logo
    // 1️⃣ Draw border
    pdf.setDrawColor(0); // black border
    pdf.setLineWidth(2);
    const padding = 5;
    pdf.rect(
      padding,
      padding,
      pageWidth - 2 * padding,
      pageHeight - 2 * padding
    );

    // 2️⃣ Add logo (centered)
    const logoImg = new Image();
    logoImg.src = logo;
    await new Promise((resolve) => {
      logoImg.onload = () => {
        pdf.addImage(logoImg, "PNG", pageWidth / 2 - 50, 20, 100, 100);
        resolve();
      };
    });

    // 3️⃣ Add title below logo
    pdf.setFontSize(16);
    pdf.setTextColor("#000");
    pdf.text("K-SAT Registration Details", pageWidth / 2, 150, {
      align: "center",
    });

    // 4️⃣ Draw fields
    const fields = [
      ["Registration No", formData.RegNo],
      ["First Name", formData.firstName],
      ["Middle Name", formData.middleName],
      ["Last Name", formData.lastName],
      ["Mobile", formData.mobile],
      ["Email", formData.email],
      ["Class", formData.class],
      ["Date of Birth", formData.dob],
      ["School Name", formData.schoolName],
      ["Father's Name", formData.fatherName],
      ["Father's Number", formData.fatherNumber],
      ["Mother's Name", formData.motherName],
      ["Mother's Number", formData.motherNumber],
      ["Exam Date", formData.examDate],
      ["Address", formData.address],
    ];

    let fieldY = 180; // start below logo
    const fieldX = 40;
    pdf.setFontSize(12);

    fields.forEach(([label, value]) => {
      pdf.setTextColor("#6c757d"); // grey label
      pdf.text(`${label}:`, fieldX, fieldY);
      pdf.setTextColor("#212529"); // dark value
      pdf.text(value || "-", fieldX + 100, fieldY);
      fieldY += 25;
    });

    // 6️⃣ Footer
    const footerY = pageHeight - 100;
    pdf.setDrawColor(200);
    pdf.setLineWidth(0.5);
    pdf.line(40, footerY - 10, pageWidth - 40, footerY - 10); // line above footer

    pdf.setFontSize(10);
    pdf.setTextColor("#495057");
    pdf.text("© 2025 kinematics_class.com", pageWidth / 2, footerY, {
      align: "center",
    });

    pdf.setFontSize(9);
    pdf.text("Contact Us:", 40, footerY + 15);
    pdf.text(
      "17, 1st floor, Avs City Square, Raj Nagar Extension, Ghaziabad, UP 201017",
      40,
      footerY + 30
    );
    pdf.text(
      "44, F Block, Raj Nagar Extension, Ghaziabad, UP 201017",
      40,
      footerY + 45
    );
    pdf.text(
      " 8527915213 , 8882028283",
      40,
      footerY + 60
    );
    pdf.text("Email: kinematicsclasses24@gmail.com", 40, footerY + 75);

    // 7️⃣ Download PDF
    pdf.save("ksat_registration.pdf");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validate fields
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.mobile ||
      !formData.fatherName ||
      !formData.fatherNumber ||
      !formData.motherName ||
      !formData.motherNumber ||
      !formData.examDate ||
      !formData.address ||
      !formData.dob ||
      !formData.schoolName
    ) {
      setErrorMessage("⚠️ Please fill in all required fields!");
      return;
    }

    try {
      setLoading(true); // show loading overlay
      const regNo = await generateExamRegNo();
      // ✅ Save all data to Firestore
      const docRef = await addDoc(collection(db, "ksat"), {
        ...formData,
        createdAt: new Date(),
        RegNo: regNo,
      });
      setFormData((prev) => ({ ...prev, RegNo: regNo || "" })); // set RegNo in formData

      alert("✅ Form submitted successfully!");
      generatePDF({ ...formData, RegNo: regNo });

      // ✅ Reset form
      setFormData({
        firstName: "",
        middleName: "",
        lastName: "",
        mobile: "",
        email: "",
        class: "",
        examDate: "",
        address: "",
        fatherName: "",
        fatherNumber: "",
        motherName: "",
        motherNumber: "",
        dob: "",
        schoolName: "",
        RegNo: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrorMessage("❌ Error submitting form. Please try again.");
    } finally {
      setLoading(false); // hide loader
    }
  };

  const validateField = (name, value) => {
    let errorMessage = "";

    // Basic required check
    if (!value.trim()) {
      errorMessage = "*This field is required";
    } else {
      // Extra validation rules
      if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errorMessage = "Please enter a valid email";
      }

      if (
        (name === "mobile" ||
          name === "fatherNumber" ||
          name === "motherNumber") &&
        !/^[0-9]{10}$/.test(value)
      ) {
        errorMessage = "Mobile number must be 10 digits";
      }

      if (name === "dob") {
        // Simple check for valid date (YYYY-MM-DD)
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          errorMessage = "Please select a valid date of birth";
        }
      }
      if (name === "schoolName" && value.length < 2) {
        errorMessage = "School name must be at least 2 characters";
      }
    }

    // Set or clear error
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (errorMessage) {
        newErrors[name] = errorMessage;
      } else {
        delete newErrors[name];
      }
      return newErrors;
    });
  };

  const classOptions = [
    "7th",
    "8th",
    "9th",
    "10th",
    "11th NEET",
    "11th JEE",
    "12th NEET",
    "12th JEE",
    "12th Pass NEET",
    "12th Pass JEE",
  ];

  return (
    <div>
      <Navbar />
      <div className="registration-page">
        <div className="container">
          <div className="header">
            <h1 className="title">
              K-SAT (Kinematics Scholastics Aptitude Test)
            </h1>
            <p>K-SAT will have complete Mathematics & Science Syllabus of your current Academic Session</p>
            {/* <h2 className="subtitle">Registration Form</h2> */}
            <p className="description">
              Fill in your details to register for the scholarship examination
              and take the first step towards your academic excellence
            </p>
          </div>
          {/* Loading Overlay */}
          {loading && (
            <div className="loading-overlay">
              <div className="spinner"></div>
              <div>Submitting your form, please wait...</div>
            </div>
          )}

          {/* Error Popup */}
          {errorMessage && (
            <div className="error-popup">
              <p>{errorMessage}</p>
              <button onClick={() => setErrorMessage("")}>Close</button>
            </div>
          )}

          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Register for K-SAT</h3>
              <div className="underline"></div>
            </div>

            <div className="card-content">
              <form onSubmit={handleSubmit} className="form">
                {/* Name Fields */}
                <div className="grid-3">
                  <div className="field">
                    <label>
                      First Name <span className="asterisk">*</span>
                    </label>
                    <input
                      value={formData.firstName || ""}
                      onChange={(e) => {
                        handleInputChange("firstName", e.target.value);
                        validateField("firstName", e.target.value);
                      }}
                      placeholder="Enter first name"
                      onBlur={(e) => validateField("firstName", e.target.value)}
                      required
                    />
                    {errors.firstName && (
                      <p className="error-text">{errors.firstName}</p>
                    )}
                  </div>
                  <div className="field">
                    <label>Middle Name</label>
                    <input
                      value={formData.middleName || ""}
                      onChange={(e) =>
                        handleInputChange("middleName", e.target.value)
                      }
                      placeholder="Enter middle name"
                    />
                  </div>
                  <div className="field">
                    <label>
                      Last Name <span className="asterisk">*</span>
                    </label>
                    <input
                      value={formData.lastName || ""}
                      onChange={(e) => {
                        handleInputChange("lastName", e.target.value);
                        validateField("lastName", e.target.value);
                      }}
                      placeholder="Enter last name"
                      onBlur={(e) => validateField("lastName", e.target.value)}
                      required
                    />
                    {errors.lastName && (
                      <p className="error-text">{errors.lastName}</p>
                    )}
                  </div>
                </div>


                {/* Contact Information */}
                <div className="grid-2">
                  <div className="field">
                    <label>
                      Mobile Number <span className="asterisk">*</span>
                    </label>
                    <input
                      type="tel"
                      value={formData.mobile || ""}
                      onChange={(e) => {
                        handleInputChange("mobile", e.target.value);
                        validateField("mobile", e.target.value);
                      }}
                      placeholder="Enter mobile number"
                      onBlur={(e) => validateField("mobile", e.target.value)}
                      required
                    />
                    {errors.mobile && (
                      <p className="error-text">{errors.mobile}</p>
                    )}
                  </div>
                  <div className="field">
                    <label>
                      Email Address <span className="asterisk">*</span>
                    </label>
                    <input
                      type="email"
                      value={formData.email || ""}
                      onChange={(e) => {
                        handleInputChange("email", e.target.value);
                        validateField("email", e.target.value);
                      }}
                      placeholder="Enter email address"
                      onBlur={(e) => validateField("email", e.target.value)}
                      required
                    />
                    {errors.email && (
                      <p className="error-text">{errors.email}</p>
                    )}
                  </div>
                </div>

                {/* Class Selection */}
                <div className="field">
                  <label>
                    Class <span className="asterisk">*</span>
                  </label>
                  <select
                    value={formData.class || ""}
                    onChange={(e) => {
                      handleInputChange("class", e.target.value);
                      validateField("class", e.target.value);
                    }}
                    onBlur={(e) => validateField("class", e.target.value)}
                    required
                  >
                    <option value="">Current Session Class</option>
                    {classOptions.map((cls) => (
                      <option key={cls} value={cls}>
                        {cls}
                      </option>
                    ))}
                  </select>
                  {errors.class && <p className="error-text">{errors.class}</p>}
                </div>

                {/* Parent Information */}
                <div className="grid-2">
                  <div className="field">
                    <label>
                      Father's Name <span className="asterisk">*</span>
                    </label>
                    <input
                      value={formData.fatherName || ""}
                      onChange={(e) => {
                        handleInputChange("fatherName", e.target.value);
                        validateField("fatherName", e.target.value);
                      }}
                      placeholder="Enter father's name"
                      onBlur={(e) =>
                        validateField("fatherName", e.target.value)
                      }
                      required
                    />
                    {errors.fatherName && (
                      <p className="error-text">{errors.fatherName}</p>
                    )}
                  </div>
                  <div className="field">
                    <label>
                      Father's Number <span className="asterisk">*</span>
                    </label>
                    <input
                      type="tel"
                      value={formData.fatherNumber || ""}
                      onChange={(e) => {
                        handleInputChange("fatherNumber", e.target.value);
                        validateField("fatherNumber", e.target.value);
                      }}
                      placeholder="Enter father's number"
                      onBlur={(e) =>
                        validateField("fatherNumber", e.target.value)
                      }
                      required
                    />
                    {errors.fatherNumber && (
                      <p className="error-text">{errors.fatherNumber}</p>
                    )}
                  </div>
                </div>

                <div className="grid-2">
                  <div className="field">
                    <label>
                      Mother's Name <span className="asterisk">*</span>
                    </label>
                    <input
                      value={formData.motherName || ""}
                      onChange={(e) => {
                        handleInputChange("motherName", e.target.value);
                        validateField("motherName", e.target.value);
                      }}
                      placeholder="Enter mother's name"
                      onBlur={(e) =>
                        validateField("motherName", e.target.value)
                      }
                      required
                    />
                    {errors.motherName && (
                      <p className="error-text">{errors.motherName}</p>
                    )}
                  </div>
                  <div className="field">
                    <label>
                      Mother's Number <span className="asterisk">*</span>
                    </label>
                    <input
                      type="tel"
                      value={formData.motherNumber || ""}
                      onChange={(e) => {
                        handleInputChange("motherNumber", e.target.value);
                        validateField("motherNumber", e.target.value);
                      }}
                      placeholder="Enter mother's number"
                      onBlur={(e) =>
                        validateField("motherNumber", e.target.value)
                      }
                      required
                    />
                    {errors.motherNumber && (
                      <p className="error-text">{errors.motherNumber}</p>
                    )}
                  </div>
                </div>

                {/* Exam Date */}
                <div className="field">
                  <label>
                    Preferred Exam Date <span className="asterisk">*</span>
                  </label>
                  {/* <select
                    value={formData.examDate || ""}
                    onChange={(e) => {
                      handleInputChange("examDate", e.target.value);
                      validateField("examDate", e.target.value);
                    }}
                    onBlur={(e) => validateField("examDate", e.target.value)}
                    required
                  >
                    <option value="">Select exam date</option>
                    {examDates.map((date) => {
                      const formatted = date.toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }); // e.g. "March 3, 2026"
                      return (
                        <option key={formatted} value={formatted}>
                          {formatted}
                        </option>
                      );
                    })}
                  </select> */}
                  <input
                    type="date"
                    value={formData.examDate || ""}
                    onChange={(e) => {
                      handleInputChange("examDate", e.target.value);
                      validateField("examDate", e.target.value);
                    }}
                    onBlur={(e) => validateField("examDate", e.target.value)}
                    required
                  />
                  {errors.examDate && (
                    <p className="error-text">{errors.examDate}</p>
                  )}
                </div>

                {/* DOB */}
                <div className="field">
                  <label>
                    Date of Birth <span className="asterisk">*</span>
                  </label>
                  <input
                    type="date"
                    value={formData.dob || ""}
                    onChange={(e) => {
                      handleInputChange("dob", e.target.value);
                      validateField("dob", e.target.value);
                    }}
                    onBlur={(e) => validateField("dob", e.target.value)}
                    required
                  />
                  {errors.dob && (
                    <p className="error-text">{errors.dob}</p>
                  )}
                </div>

                {/* School Name */}
                <div className="field">
                  <label>
                    School Name <span className="asterisk">*</span>
                  </label>
                  <input
                    value={formData.schoolName || ""}
                    onChange={(e) => {
                      handleInputChange("schoolName", e.target.value);
                      validateField("schoolName", e.target.value);
                    }}
                    placeholder="Enter school name"
                    onBlur={(e) => validateField("schoolName", e.target.value)}
                    required
                  />
                  {errors.schoolName && (
                    <p className="error-text">{errors.schoolName}</p>
                  )}
                </div>

                {/* Address */}
                <div className="field">
                  <label>
                    Residential Address <span className="asterisk">*</span>
                  </label>
                  <input
                    value={formData.address || ""}
                    onChange={(e) => {
                      handleInputChange("address", e.target.value);
                      validateField("address", e.target.value);
                    }}
                    placeholder="Enter complete address"
                    rows={4}
                    onBlur={(e) => validateField("address", e.target.value)}
                    required
                  />
                  {errors.address && (
                    <p className="error-text">{errors.address}</p>
                  )}
                </div>
                <button type="submit" className="submit-btn">
                  Register
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default KsatRegistration;
